import './set-box-global';

import React from 'react';

import ReactDOM from 'react-dom/client';

import App from './App';
import reportWebVitals from './reportWebVitals';

import './index.css';

const root = ReactDOM.createRoot(document.getElementById('root'));

try {
  fetch('/src/env-config.json')
    .then(response => response.json())
    .then(data => {
      window.ENV_CONFIG = data;
      // The i18n provider reads the store URL from window.RMM before it renders.
      window.RMM = window.RMM || {};
      if (data.i18nStoreUrl) {
        window.RMM.i18nStoreUrl = data.i18nStoreUrl;
      }
      render();
    })
    .catch(() => {
      console.warn('ENV file not found at public/src/env-config.json');
      render();
    });
} catch (error) {
  console.warn('ENV file not found at public/src/env-config.json');
}

const render = () => {
  root.render(
    <App />
  );
};

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
